exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".proposal-overlay-content-save {\n  position: fixed;\n  display: none;\n  width: 100%;\n  height: 100%;\n  top: 18px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 999;\n  cursor: pointer;\n  background: rgba(255, 255, 255, .8509803922);\n}\n.proposal-overlay-content-save img {\n  position: absolute;\n  right: 42.5%;\n  top: 18%;\n}\n.proposal-overlay-content-save h1 {\n  position: absolute;\n  color: #01b1af;\n  top: 50%;\n  right: 42.5%;\n  font-weight: 200;\n}\n.upload-doc-button {\n  position: fixed;\n  bottom: 10px;\n  display: block;\n  right: 18vw;\n}\n", ""]);

// exports
